import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClientWorkstreamData } from '@modules/EvaluationModule/interfaces/ClientWorkstreamData';
import { AsyncData } from '@shared/interfaces/asyncData';
import { DataState } from '@shared/enums/DataState';
import { getClientWorkstreamsData } from '../redux/actions';
import { clientWorkstreamsDataSelector } from '../redux/selectors';
import { CONTACTS_CACHE_TTL_MS } from '../cacheConstants';

/**
 * Zoho's view of one client's workstreams (real + pseudo), cached per client id. SubProjectTable
 * renders the DB workstreams from /my-projects-list first and merges this in when it arrives.
 */
export const useClientWorkstreamsData = (clientId: string | null): AsyncData<ClientWorkstreamData[]> => {
  const entry = useSelector(clientWorkstreamsDataSelector(clientId));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!clientId) {
      return;
    }
    const isFresh =
      entry.state === DataState.Fulfilled &&
      entry.fetchedAt !== null &&
      Date.now() - entry.fetchedAt < CONTACTS_CACHE_TTL_MS;
    if (isFresh) {
      return;
    }
    dispatch(getClientWorkstreamsData({ clientId }));
    // Keying by clientId (both here and in the store) is the stale-response guard: a response
    // for a client that's no longer selected lands under its own key and never overwrites the
    // currently-selected client's view.
  }, [clientId]);

  return entry;
};
